<template>
    <button v-on:click="clickHandler" :disabled="this.disabled" :class="this.classObject">
        <slot v-if="!this.showWaitText"/>
        <span v-if="this.showWaitText">{{this.waitText}}..</span>
    </button>
</template>

<script>
    export default {
        name: "AuctionButton",
        props: {
            disabled: Boolean,
            color: String,
            waitText: String,
            inProgress: Boolean,
            confirmText: {
                String,
                default: null
            }
        },
        data() {
            return {}
        },
        methods: {
            clickHandler() {
                if (!this.inProgress) {
                    if (this.confirmText === null) {
                        this.$emit('click');
                        return;
                    }
                    if (confirm(this.confirmText)) {
                        this.$emit('click');
                    }
                }
            }
        },
        computed: {
            classObject: function() {
                return {
                    'awa-btn': true,
                    'awa-btn-green': this.color === 'green' && !this.disabled,
                    'awa-btn-orange': this.color === 'orange'  && !this.disabled,
                    'awa-btn-blue': this.color === 'blue'  && !this.disabled,
                    'awa-btn-red': this.color === 'red' && !this.disabled,
                    'opacity-25 awa-btn-gray cursor-not-allowed': this.disabled,
                }
            },
            showWaitText: function() {
                return this.waitText && this.inProgress;
            }
        }
    }
</script>
